// extracted by mini-css-extract-plugin
module.exports = {"tab_wrapper":"list-situation-cards_tab_wrapper__3p6Nb"};